import { format, parseISO } from 'date-fns';

export type ItemPrice = {
  id?: number;
  fromDate?: string | null;
  price?: number | null;
  priceCalculationMethod?: number | null;
  isActive?: boolean | null;
};

/** Ίδιες ετικέτες με τη φόρμα δήλωσης εισφοράς */
export function priceCalculationMethodLabel(
  method: number | null | undefined,
  t: (s: string) => string,
): string {
  if (method === 1) return t('Εισφορά ανά Τεμάχιο');
  if (method === 2) return t('Εισφορά ανά Κιλό');
  // τεμάχια × Ah
  if (method === 3) return t('Εισφορά ανά Τεμάχιο');
  return '';
}

export function formatPrice(value: number | null | undefined): string {
  if (value == null || Number.isNaN(Number(value))) return '';
  return Number(value).toLocaleString('el-GR', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 6,
  });
}

export function formatDateSafe(value?: string | null): string {
  if (!value) return '';
  try {
    return format(parseISO(value), 'dd/MM/yyyy');
  } catch {
    return '';
  }
}

/**
 * Ισχύουσα τιμή του είδους: η πιο πρόσφατη ενεργή εγγραφή.
 * Αν δεν υπάρχει ενεργή, παίρνει την πιο πρόσφατη ανεξάρτητα κατάστασης.
 */
export function currentItemPrice(prices?: ItemPrice[] | null): ItemPrice | undefined {
  const list = [...(prices ?? [])].filter((p) => p?.fromDate);
  const active = list.filter((p) => p.isActive !== false);
  const source = active.length > 0 ? active : list;
  source.sort((a, b) => String(b.fromDate).localeCompare(String(a.fromDate)));
  return source[0];
}

/** Όλες οι τιμές, νεότερη πρώτη, για εμφάνιση στο ίδιο grid με το είδος */
export function formatPriceHistory(
  prices: ItemPrice[] | null | undefined,
  t: (s: string) => string,
): string {
  const list = [...(prices ?? [])].sort((a, b) =>
    String(b.fromDate ?? '').localeCompare(String(a.fromDate ?? '')),
  );
  return list
    .map((p) => {
      const inactive = p.isActive === false ? ` (${t('ανενεργή')})` : '';
      return `${formatDateSafe(p.fromDate)}: ${formatPrice(p.price)}${inactive}`;
    })
    .join('\n');
}

/** Πού χρησιμοποιείται το είδος (ΕΜΠΑ / ΕΔΟΕ) */
export function itemUsageLabel(
  item: {
    useInEmpa?: boolean | null;
    useInEdoe?: boolean | null;
    useInEdoeUsed?: boolean | null;
    useInNonEdoe?: boolean | null;
  },
  t: (s: string) => string,
): string {
  const parts: string[] = [];
  if (item.useInEmpa) parts.push(t('ΕΜΠΑ'));
  if (item.useInEdoe) parts.push(t('ΕΔΟΕ'));
  if (item.useInEdoeUsed) parts.push(t('ΕΔΟΕ μεταχειρισμένα'));
  if (item.useInNonEdoe) parts.push(t('εκτός ΕΔΟΕ'));
  return parts.join(', ');
}
